/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_Delete_FailedInputs */

const en_us2_coach_manage_delete_failed = /** @type {(inputs: Coach_Manage_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't delete the conversation. Check your connection and try again.`)
};

const pt_br2_coach_manage_delete_failed = /** @type {(inputs: Coach_Manage_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para apagar a conversa. Confira a internet e tente de novo.`)
};

const es_419_coach_manage_delete_failed = /** @type {(inputs: Coach_Manage_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar la conversación. Revisa tu conexión e inténtalo de nuevo.`)
};

const pt_pt2_coach_manage_delete_failed = /** @type {(inputs: Coach_Manage_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível apagar a conversa. Verifica a ligação e tenta de novo.`)
};

const fr_fr2_coach_manage_delete_failed = /** @type {(inputs: Coach_Manage_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de supprimer la conversation. Vérifie ta connexion et réessaie.`)
};

const de_de2_coach_manage_delete_failed = /** @type {(inputs: Coach_Manage_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Unterhaltung konnte nicht gelöscht werden. Prüf deine Verbindung und versuch es erneut.`)
};

const it_it2_coach_manage_delete_failed = /** @type {(inputs: Coach_Manage_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile eliminare la conversazione. Controlla la connessione e riprova.`)
};

/**
* | output |
* | --- |
* | "Couldn't delete the conversation. Check your connection and try again." |
*
* @param {Coach_Manage_Delete_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_delete_failed = /** @type {((inputs?: Coach_Manage_Delete_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Delete_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_delete_failed(inputs)
	if (locale === "es-419") return es_419_coach_manage_delete_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_delete_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_delete_failed(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_delete_failed(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_delete_failed(inputs)
	return en_us2_coach_manage_delete_failed(inputs)
});
export { coach_manage_delete_failed as "coach-manage.delete_failed" }